// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___2whRY","visible-sm":"visible-sm___PaOsB","visible-md":"visible-md___2A0gW","visible-lg":"visible-lg___Z1Nkh","row":"row___2VxS3","hidden-xs":"hidden-xs___YKnWX","hidden-sm":"hidden-sm___yQvP1","hidden-md":"hidden-md___zXmDZ","hidden-lg":"hidden-lg___20j96","eeo-wrap":"eeo-wrap___3QR1x space-top-12___3DU92 space-bottom-12___rGCm0","img":"img___3MuT3","lede":"lede___1vqNf h3___5u0xZ","statement-wrap":"statement-wrap___3nPrK center___2iqBf","statement":"statement___dHhGx","contact":"contact___1TsPA space-top-6___2l-qx space-bottom-12___rGCm0 h5___l1yk7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DiversityEeoStatement/DiversityEeoStatement.css
// module id = 856
// module chunks = 0